import type { GambitChatDto, MessageDto, PlayerChatDto } from '@/core/data/chat/chat.interface';
import { ChatEndpoint } from '@/core/network/api/constants/api.url.constant';
import { HttpClient } from '@/core/network/http/httpClient';
import type { GamResponse } from '@/core/network/http/httpClient.interface';
import type { AxiosResponse } from 'axios';

export class ChatApi {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async getChat(chatId: string): Promise<AxiosResponse<GamResponse<GambitChatDto | PlayerChatDto>>> {
    return this.httpClient.get<GambitChatDto | PlayerChatDto>(ChatEndpoint.CHAT, {
      urlParams: { id: chatId },
    });
  }

  async createGambitChat(gambitId: string): Promise<AxiosResponse<GamResponse<GambitChatDto>>> {
    return this.httpClient.post(ChatEndpoint.CHATS, {
      data: { gambitId },
    });
  }

  async createFirestoreDoc(id: string): Promise<AxiosResponse<GamResponse<any>>> {
    return await this.httpClient.put(ChatEndpoint.CHAT_FIRESTORE, {
      urlParams: { id },
    });
  }

  async markChatAsRead(chatId: string): Promise<AxiosResponse<GamResponse<void>>> {
    return this.httpClient.put(ChatEndpoint.CHAT_READ, {
      urlParams: { id: chatId },
    });
  }

  async getMessages(chatId: string, afterCursor?: string): Promise<AxiosResponse<GamResponse<MessageDto[]>>> {
    return this.httpClient.get<MessageDto[]>(ChatEndpoint.GAMBIT_CHAT_MESSAGES, {
      urlParams: { id: chatId },
      config: {
        params: { afterCursor },
      },
    });
  }

  async postMessage(chatId: string, body: string): Promise<AxiosResponse<GamResponse<void>>> {
    return await this.httpClient.post(ChatEndpoint.MESSAGES, {
      urlParams: { id: chatId },
      data: { body },
    });
  }

  async deleteMessage(chatId: string, messageId: string): Promise<AxiosResponse<GamResponse<void>>> {
    return await this.httpClient.delete(ChatEndpoint.MESSAGE, {
      urlParams: { chatId, messageId },
    });
  }
}
